/**
 * Get current language from URL path
 * @returns {string|null} Language code ('nl', 'fr') or null if not found
 */
export const getCurrentLanguage = () => {
  if (typeof window === 'undefined') return null;

  const pathName = window?.location?.pathname?.toLowerCase() || '';

  if (pathName.substring(0, 3) === '/nl') {
    return 'nl';
  } else if (pathName.substring(0, 3) === '/fr') {
    return 'fr';
  }

  return null;
};

/**
 * Get current locale from URL path or provided locale
 * @param {string|null} locale - Optional locale string (e.g., 'nl-be', 'fr-be', 'fr-lu')
 * @returns {string|null} Locale string or null if not found
 */
export const getCurrentLocale = (locale = null) => {
  if (locale) {
    return locale;
  }

  const language = getCurrentLanguage();
  if (!language) return null;

  // Try to determine country from domain or default to 'be'
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const country = hostname.includes('lu') ? 'lu' : 'be';

  return `${language}-${country}`;
};

/**
 * Check if current language is Dutch
 * @param {string|null} locale - Optional locale string
 * @returns {boolean} True if language is Dutch
 */
export const isDutch = (locale = null) => {
  const currentLocale = getCurrentLocale(locale);
  return currentLocale ? currentLocale.startsWith('nl') : false;
};

/**
 * Check if current language is French
 * @param {string|null} locale - Optional locale string
 * @returns {boolean} True if language is French
 */
export const isFrench = (locale = null) => {
  const currentLocale = getCurrentLocale(locale);
  return currentLocale ? currentLocale.startsWith('fr') : false;
};

/**
 * Get page title based on B2C status and language
 * @param {boolean} isB2c - Whether the user is B2C or B2B
 * @param {string|null} locale - Optional locale string to determine language
 * @returns {string} The appropriate page title
 */
export const getPageTitle = (isB2c, locale = null) => {
  const currentLocale = getCurrentLocale(locale);
  const isNl = isDutch(currentLocale);

  if (isB2c) {
    return isNl ? "Kia | Particulieren" : "Kia | Particuliers";
  } else {
    return isNl ? "Kia | Professionals" : "Kia | Professionnels";
  }
}; 